export default "__VITE_ASSET__CRRGJuPk__"